import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import classNames from 'classnames/bind';

import { DataBlocks, I18n } from 'components';

import TvConsoleWithActions from './containers/TvConsoleWithActions';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const NotifiableActionsForTvConsoles = (props) => {
  if (props.tvConsolesFetchingError) {
    return null;
  }

  return (
    <DataBlocks.Block
      title={<I18n path="settings.notifications.notifiableActionsForTvConsolesTitle" />}
      isLoading={props.isTvConsolesFetching}
    >
      {(!props.tvConsoles || isEmpty(props.tvConsoles)) && (
        <div className={cx('emptyMessage')}>
          <I18n path="settings.notifications.emptyMessageForTvConsoles" />
        </div>
      )}
      {props.tvConsoles && props.tvConsoles.map((tvConsole) => (
        <TvConsoleWithActions
          key={tvConsole.guid}
          fetch={props.fetchTvActions}
          save={props.saveTvActions}
          guid={tvConsole.guid}
          guidType={tvConsole.guidType}
          label={tvConsole.label}
        />
      ))}
    </DataBlocks.Block>
  );
};

NotifiableActionsForTvConsoles.propTypes = {
  tvConsoles: PropTypes.array,
  isTvConsolesFetching: PropTypes.bool,
  tvConsolesFetchingError: PropTypes.string,
  fetchTvActions: PropTypes.func,
  saveTvActions: PropTypes.func,
};

export default NotifiableActionsForTvConsoles;
